export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7467.2a9bb4e8.jpg";